// These exports are using the .default prop of the module because we're mixing ES6 and ES5. This is required for
// webpack to be able to correctly split bundles.
import { LoadablePaint, LoadableAfterPaint, LoadableLazy } from '@confluence/loadable';

export const LazySpaceBlogRedirect = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SpaceBlogRedirect" */ '../SpaceBlogRedirect'))
			.SpaceBlogRedirect,
});

export const LazySpaceCreatePage = LoadablePaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-containersCreatePageContainer" */ '../../containers/CreatePageContainer'
		),
});

export const LazyMobileWebContainer = LoadablePaint({
	loader: () =>
		import(/* webpackChunkName: "loadable-MobileWebContainer" */ '../MobileWebContainer'),
});

export const LazyDwellTime = LoadableLazy({
	loader: () => import(/* webpackChunkName: "loadable-DwellTime" */ '../DwellTime'),
});

// this is to fix an error in typechecking because the ConsumptionViewedAndCompletedEventTracker type is not exported
/** @type {any} */
export const LazyConsumptionViewedAndCompletedEventTracker = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-confluenceunified-analyticsentry-pointsConsumptionViewedAndCompletedEventTracker" */ '@confluence/unified-analytics/entry-points/ConsumptionViewedAndCompletedEventTracker'
			)
		).ConsumptionViewedAndCompletedEventTracker,
});

export const LazyConfluenceNotFound = LoadableAfterPaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-containersConfluenceNotFoundContainer" */ '@confluence-classic/confluence-utils/src/components/ConfluenceNotFound/ConfluenceNotFoundContainer'
		),
});
